import { BillingPeriodType } from '@constants/billingPeriods'
import { newLandingiClient } from '@lib/http/client'

import { getBillingPeriodId } from './helpers/getBillingPeriodId'

export const requestInvoice = ({
  billingPeriod,
  csrfToken
}: {
  billingPeriod: BillingPeriodType
  csrfToken: string
}) => {
  const requestInvoiceData = {
    period: getBillingPeriodId({ billingPeriod }),
    gateway: 'invoice'
  }

  return newLandingiClient.post('/payments/prepare', requestInvoiceData, {
    headers: {
      'X-CSRF-TOKEN': csrfToken,
      'Content-Type': 'multipart/form-data'
    }
  })
}
